// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1cIcQ","footer":"ModalError_footer__2BcAr"};